export const NAMESPACE = 'botspecs';

export const UPDATE_BOTSPECS = `${NAMESPACE}/update`;
export const UPDATE_PARSING_BOTSPEC = `${NAMESPACE}/update/parsing`;
export const UPDATE_EDITOR_ERROR = `${NAMESPACE}/update/editor_error`;
export const UPDATE_SELECTED_BOTSPEC = `${NAMESPACE}/select`;
export const UPDATE_SELECTED_VARIABLE_GROUP = `${NAMESPACE}/UPDATE_SELECTED_VARIABLE_GROUP`;
export const UPDATE_SELECTED_FUNCTION_GROUP = `${NAMESPACE}/UPDATE_SELECTED_FUNCTION_GROUP`;
export const UPDATE_SELECTED_STORAGE_GROUP = `${NAMESPACE}/UPDATE_SELECTED_STORAGE_GROUP`;
export const RESET_SELECTIONS = `${NAMESPACE}/RESET_SELECTIONS`;
export const UPDATE_LOADING_BOTSPECS = `${NAMESPACE}/update/loadingBotspecs`;
export const LOADING_BOT_ERROR_GROUPS = `${NAMESPACE}/LOADING_BOT_ERROR_GROUPS`;
export const UPDATE_BOT_ERROR_GROUPS = `${NAMESPACE}/UPDATE_BOT_ERROR_GROUPS`;
export const LOADING_BOT_ERRORS_DETAILS = `${NAMESPACE}/LOADING_BOT_ERRORS_DETAILS`;
export const UPDATE_BOT_ERRORS_DETAILS = `${NAMESPACE}/UPDATE_BOT_ERRORS_DETAILS`;
export const RESET_CHATBOTS = `${NAMESPACE}/RESET_CHATBOTS`;
export const RESTORE_BOTSPEC_PAST_STATE = `${NAMESPACE}/RESTORE_BOTSPEC_PAST_STATE`;
export const UPDATE_BOTSPEC_PARSER_ERRORS = `${NAMESPACE}/UPDATE_BOTSPEC_PARSER_ERRORS`;
export const CREATE_FOLDER = `${NAMESPACE}/folders/create`;
export const UPDATE_FOLDERS = `${NAMESPACE}/folders/update`;
export const UPDATE_TEMPLATES = `${NAMESPACE}/templates/update`;
export const UPDATE_CHATBOTS = `${NAMESPACE}/chatbots/update`;
export const UPDATE_CURRENT_BUSINESS_UNITS = `${NAMESPACE}/currentBusinessUnits/update`;
